type Attribute = { title: string; value: string; image: string }

export function useAttributes(article: Ref<any | null>) {
    const attributes = computed<Attribute[]>(() => {
        const a = article.value;
        if (!a) return [];
        const out: Attribute[] = [];

        const from = a.ageGroupFrom;
        const to = a.ageGroupTo;
        if (from != null || to != null) {
            let value = 'keine Altersbeschränkung';
            if (from > 0 && from < 13) {
                value = (to > 0 && to < 13) ? `geeignet von ${from} bis ${to} Jahre` : `geeignet ab ${from} Jahre`;
            } else if (to > 0 && to < 13) {
                value = `geeignet bis ${to} Jahre`;
            }
            out.push({title: 'Altersgruppe', value, image: 'attr_644.svg'});
        }

        if (a.baseAreaWidth > 0 && a.baseAreaDepth > 0) {
            out.push({title: 'Grundfläche', value: `ca. ${a.baseAreaWidth} x ${a.baseAreaDepth} m`, image: 'attr_646.svg'});
        } else if (a.baseAreaDiameter > 0) {
            out.push({title: 'Grundfläche', value: `ca. ${a.baseAreaDiameter} m Durchmesser`, image: 'attr_646.svg'});
        }

        if (a.safetyAreaWidth > 0 && a.safetyAreaDepth > 0) {
            out.push({title: 'Inkl. Sicherheitsbereich', value: `ca. ${a.safetyAreaWidth} x ${a.safetyAreaDepth} m`, image: 'attr_645.svg'});
        } else if (a.safetyAreaDiameter > 0) {
            out.push({title: 'Inkl. Sicherheitsbereich', value: `ca. ${a.safetyAreaDiameter} m Durchmesser`, image: 'attr_645.svg'});
        }

        if (a.freeFallHeight > 0) out.push({title: 'Freie Fallhöhe', value: `ca. ${a.freeFallHeight} m`, image: 'attr_647.svg'});
        if (a.totalHeight > 0) out.push({title: 'Gesamthöhe', value: `ca. ${a.totalHeight} m`, image: 'attr_651.svg'});

        if (a.largestSinglePartDepth > 0 && a.largestSinglePartWidth > 0 && a.largestSinglePartHeight > 0) {
            out.push({
                title: 'Größtes Einzelteil',
                value: `${a.largestSinglePartWidth} x ${a.largestSinglePartDepth} x ${a.largestSinglePartHeight} m`,
                image: 'attr_648.svg',
            });
        }

        if (a.heaviestSinglePart > 0) out.push({title: 'Schwerstes Einzelteil', value: `ca. ${a.heaviestSinglePart} kg`, image: 'attr_653.svg'});
        if (a.postShoes) out.push({title: 'Pfostenschuhe', value: String(a.postShoes), image: 'attr_652.svg'});
        if (a.foundations) out.push({title: 'Fundamente', value: String(a.foundations), image: 'attr_650.svg'});

        return out;
    });

    return {attributes};
}
